import axios from "axios";
import { toast } from "sonner";

const authapi = axios.create({
  timeout: 10000,
  baseURL: process.env.REACT_APP_AUTH_API_URL || "http://localhost:9543/api/v1",
});

authapi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access-token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

authapi.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { status, response } = error;

    let data = response?.data;

    if (data instanceof Blob) {
      try { data = JSON.parse(await data.text()) } catch { data = null }
    }

    switch (status) {
      case 400:
        if (data?.ExceptionMessage) {
          toast.error(`Hata (400): ${data.ExceptionMessage}`);
        } else {
          toast.error("İstek geçersiz. (400)");
        }
        break;
      case 422:
        toast.error(`Doğrulama Hatası (422): ${data?.Message || "Gönderilen veri formatı geçersiz."}`);
        break;
      case 500:
        toast.error(`Sunucu Hatası (500): ${data?.ExceptionMessage || "Beklenmedik bir sunucu hatası oluştu."}`);
        break;
      case 401:
        toast.error("Yetkisiz Erişim (401): E-posta, şifre hatalı veya oturumunuz geçersiz.");
        break;
      default:
        toast.error("Bağlantı Hatası: İnternet bağlantınızı kontrol edin veya sunucuya ulaşılamıyor.");
        break;
    }

    return Promise.reject(error);
  }
);

export default authapi;

export const loginApi = (uniqueValue, password) =>
  authapi.post('Auth/token', { uniqueValue, password });

export const twoFactorLogin = (userId, code) =>
  authapi.post('Auth/two-factor', { userId, code });

